/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import routes from './routes';
import { auth, auth1, getCachedStore } from './auth';
import { getToken } from '../service/helper';

Vue.use(Router);

const router = new Router({
  mode: 'hash', // require service support
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  if (auth1(to)) {
      next();
      return;
  }
    if(!getToken()){
        next(`/signin?redirect=${to.path}`);
      return;
    }
      next();
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});

export default router;
